import React, { useState } from "react";
import "../styles/comingSoon.scss";

function ComingSoon() {
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [loading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleNotifyMe = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setIsEmailValid(false);
      setError("Please enter your email address");
      return;
    }
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      setIsEmailValid(false);
      return;
    }
    setIsLoading(true);
    fetch("https://hub.cxhope.ai/api/v1/users/handleWebsiteRequest", {
      method: "POST",
      body: JSON.stringify({ email }),
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (response.status === 200) {
          setIsEmailValid("success");
          setEmail("");
        }
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const handleEnter = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleNotifyMe();
    }
  };

  return (
    <div className="coming-soon">
      <div className="sphere-container">
        {" "}
        <div className="seventh-sphere">
          {" "}
          <img
            src="/images/hopeIcon.png"
            alt="hope icon"
            style={{
              width: "70px",
              height: "100px",
              position: "fixed",
              left: "34%",
              bottom: 40,
            }}
            className="hope-icon"
          />{" "}
        </div>{" "}
        <div className="circle"></div> <div className="circle"></div>{" "}
        <div className="circle"></div> <div className="circle"></div>{" "}
        <div className="circle"></div> <div className="circle"></div>{" "}
        <div className="circle"></div>{" "}
      </div>

      <div className="content">
        <img
          src="/cxLogos/cxLogo.svg"
          alt="cx-logo"
          style={{ width: "80px", height: "45px", filter: "invert(100%)" }}
        />
        <h1 style={{ marginTop: "3rem" }}>COMING SOON</h1>
        <p>Something revolutionary is on the horizon.</p>
        {isEmailValid === "success" ? (
          <div className="mt-5">
            <p>Thank you! We’ve received your email address.</p>
            <p>We’ll let you know as soon as the website is live!</p>
          </div>
        ) : (
          <>
            <div className="notify-me">
              <div className="input-wrapper">
                <img
                  src="/images/mail-icon.png"
                  alt="Mail Icon"
                  className="mail-icon"
                />
                <input
                  type="email"
                  placeholder="Notify Me"
                  className="email-input"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if(!isEmailValid){
                      setIsEmailValid(true)
                    }
                  }}
                  onKeyDown={handleEnter}
                />
                <button
                  className="notify-button"
                  onClick={handleNotifyMe}
                  disabled={loading}
                >
                  {!loading ? (
                    <span className="arrow-icon">{">"}</span>
                  ) : (
                    <div className="loader"></div>
                  )}
                </button>
              </div>
            </div>
            {isEmailValid === false && (
              <span
                style={{ fontSize: "12px" }}
                className="text-danger fw-light"
              >
                * {error}
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ComingSoon;
